import { Button, Modal, setPromiseSnack } from "@synthesis/shared-ui";
import { useQueryClient } from "@tanstack/react-query";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { invalidateInternalApplicationQueries } from "../../../shared/utils/invalidate-application-queries";
import {
  deleteRegionDepartment,
  REGION_DEPARTMENTS_DELETE_SNACK_MESSAGES,
  type RegionDepartment,
} from "./application-control-region-departments-modal.lib";

type DeleteRegionDepartmentModalProps = {
  requestId: string;
  department: RegionDepartment | null;
  departments: RegionDepartment[];
  onClose: () => void;
};

export const DeleteRegionDepartmentModal = observer(({ requestId, department, departments, onClose }: DeleteRegionDepartmentModalProps) => {
  const queryClient = useQueryClient();
  const [isDeleting, setIsDeleting] = useState(false);

  if (!department) {
    return null;
  }

  const handleSubmit = () => {
    const promise = (async () => {
      setIsDeleting(true);

      try {
        await deleteRegionDepartment(requestId, departments, department.id);
        await invalidateInternalApplicationQueries(queryClient, requestId);
        onClose();
      } finally {
        setIsDeleting(false);
      }
    })();

    setPromiseSnack({
      promise,
      promiseSettings: {
        title: REGION_DEPARTMENTS_DELETE_SNACK_MESSAGES,
      },
    });
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Modal.Root isOpen setIsOpen={handleOpenChange}>
      <Modal.Content className="flex max-h-[calc(100vh-4rem)] w-[520px] flex-col overflow-hidden">
        <Modal.Title>Удалить назначение подразделения</Modal.Title>
        <div className="flex flex-col gap-4 px-8 pb-2 pt-6">
          <h3 className="heading-h4 text-type-common">Удалить назначение подразделения «{department.name}»</h3>
          <p className="paragraph-base text-type-minor">Вы сможете назначить это подразделение снова.</p>
        </div>
        <div className="flex shrink-0 gap-4 px-8 pb-6 pt-2">
          <Button type="button" theme="primary" size="lg" disabled={isDeleting} onClick={handleSubmit}>
            Удалить
          </Button>
          <Button type="button" theme="secondary" size="lg" disabled={isDeleting} onClick={onClose}>
            Отмена
          </Button>
        </div>
      </Modal.Content>
    </Modal.Root>
  );
});
